import { render, staticRenderFns } from "./ItemData.vue?vue&type=template&id=677f1564&"
import script from "./ItemData.vue?vue&type=script&lang=js&"
export * from "./ItemData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports